import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";

import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

import { Home } from "./pages/Home";
import { FindHome } from "./pages/FindHome";
import { LetProperty } from "./pages/LetProperty";
import { MoveDispatch } from "./pages/MoveDispatch";
import { Partners } from "./pages/Partners";
import { About } from "./pages/About";
import { Faqs } from "./pages/Faqs";
import { Contact } from "./pages/Contact";
import { Privacy } from "./pages/legal/Privacy";
import { Terms } from "./pages/legal/Terms";
import { Aml } from "./pages/legal/Aml";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { TenantDashboard } from "./pages/TenantDashboard";
import { LandlordDashboard } from "./pages/LandlordDashboard";
import { ConciergeAdminDesk } from "./pages/ConciergeAdminDesk";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-[#F9FBFF]">
        <div className="w-8 h-8 border-[3px] border-[#091F5C] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === "admin") return <Navigate to="/admin/desk" replace />;
    if (user.role === "landlord") return <Navigate to="/landlord/dashboard" replace />;
    return <Navigate to="/tenant/dashboard" replace />;
  }

  return children;
};

function AppContent() {
  return (
    <div className="flex flex-col min-h-screen bg-[#F9FBFF] text-[#091F5C]">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find" element={<FindHome />} />
          <Route path="/let" element={<LetProperty />} />
          <Route path="/move" element={<MoveDispatch />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/aml" element={<Aml />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/tenant/dashboard"
            element={
              <ProtectedRoute allowedRoles={["tenant", "admin"]}>
                <TenantDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/landlord/dashboard"
            element={
              <ProtectedRoute allowedRoles={["landlord", "admin"]}>
                <LandlordDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/desk"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ConciergeAdminDesk />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
